import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

export const TABLE_VIEW_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<PipelineStepType.TABLE_VIEW, 0> = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['viewName'],
  viewName: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['viewName'],
    viewName: {
      displayName: 'Table name',
      configShapePath: ['viewName'],
    },
  },
};
